/** Shared color constants for the decision tree editor. */

/** Purple — orphan/unlinked nodes and edges */
export const ORPHAN_PURPLE = "#8B5CF6";
/** Blue — cross-orphan edges (reconnecting unlinked node to main tree) */
export const CROSS_ORPHAN_BLUE = "#3B82F6";
/** Amber — cross-connect edges (linking from main tree to unlinked node) */
export const CROSS_CONNECT_AMBER = "#F59E0B";
